import axios from '@fs/zion-axios'
import utils from './utils'

const treeDataBase = '/service/tree/tree-data'

const listService = {
  getFollowedPersonsCount() {
    const url = `${treeDataBase}/followers/CURRENT/persons/count`
    return axios.get(url).then((res) => res.data.count)
  },

  getFollowedChangesList({ filter, showMyChanges, pageToken } = {}) {
    let url = `${treeDataBase}/followers/CURRENT/changes?count=50`
    if (filter) {
      url += `&nameFilter=${filter}`
    }
    if (showMyChanges === utils.HIDE_MY_CHANGES) {
      url += '&includeMyChanges=false'
    }
    if (pageToken) {
      url += `&token=${pageToken}`
    }
    return axios.get(url).then((res) => res.data)
  },

  getFollowedPersonsList({
    sortBy,
    sortDirection,
    filter,
    labelFilter,
    showMyChanges,
    includeAllTrees,
    count,
    pageToken,
  } = {}) {
    let url = `${treeDataBase}/followers/CURRENT/persons?count=${count || 50}`
    if (utils.showNamesInRomanScript) {
      url += `&preferRomanScript=${utils.showNamesInRomanScript}`
    }
    if (sortBy) {
      url += `&sort=${sortBy}`
    }
    if (sortDirection) {
      url += `&order=${sortDirection}`
    }
    if (filter) {
      url += `&nameFilter=${filter}`
    }
    if (labelFilter && labelFilter !== utils.FILTER_ALL) {
      url += `&labelFilter=${labelFilter}`
    }
    if (showMyChanges === utils.HIDE_MY_CHANGES) {
      url += '&includeMyChanges=false'
    }
    if (includeAllTrees) {
      url += `&includeAllTrees=${includeAllTrees}`
    }
    if (pageToken) {
      url += `&token=${pageToken}`
    }
    return axios.get(url).then((res) => res.data)
  },

  getPersonChanges(personId, showMyChanges, pageToken) {
    let url = `${treeDataBase}/followers/CURRENT/changes?personId=${personId}&count=50`
    if (showMyChanges === utils.HIDE_MY_CHANGES) {
      url += '&includeMyChanges=false'
    }
    if (pageToken) {
      url += `&token=${pageToken}`
    }
    return axios.get(url).then((res) => res.data)
  },

  getUserLabels(show) {
    let url = `${treeDataBase}/followers/CURRENT/labels`
    if (show) url += `?show=${show}`
    return axios.get(url).then((res) => res.data)
  },

  // Custom labels
  getUserCustomLabel(labelId) {
    const url = `${treeDataBase}/followers/CURRENT/labels/${labelId}`
    return axios.get(url).then((res) => res.data)
  },

  createUserCustomLabel(newLabelTitle) {
    const url = `${treeDataBase}/followers/CURRENT/labels`
    return axios.post(url, { title: newLabelTitle }).then((res) => res.data)
  },

  editUserCustomLabel(labelId, updatedLabel) {
    const url = `${treeDataBase}/followers/CURRENT/labels/${labelId}`
    return axios.put(url, updatedLabel).then((res) => res.data)
  },

  deleteUserCustomLabel(labelId) {
    const url = `${treeDataBase}/followers/CURRENT/labels/${labelId}`
    return axios.delete(url)
  },

  // Persons' labels
  getPersonLabels(personId) {
    const url = `${treeDataBase}/followers/CURRENT/persons/${personId}/labels`
    return axios.get(url).then((res) => res.data)
  },

  addPersonLabel(personId, newLabel) {
    const url = `${treeDataBase}/followers/CURRENT/persons/${personId}/labels`
    return axios.post(url, newLabel).then((res) => res.data)
  },

  editPersonLabel(personId, labelId, updatedLabel) {
    const url = `${treeDataBase}/followers/CURRENT/persons/${personId}/labels/${labelId}`
    return axios.put(url, updatedLabel).then((res) => res.data)
  },

  deletePersonLabel(personId, labelId) {
    const url = `${treeDataBase}/followers/CURRENT/persons/${personId}/labels/${labelId}`
    return axios.delete(url)
  },

  getRelationship(personId) {
    const url = `${treeDataBase}/user-relationship/person/${personId}?showApexCoParentEx=true`
    return axios.get(url).then((res) => res.data)
  },

  getContributor(userId) {
    const url = `${treeDataBase}/user/${userId}/contact-info`
    return axios.get(url).then((res) => res.data.data)
  },

  // Recommended Followees
  getRecommendedFollowees() {
    const url = `${treeDataBase}/followers/CURRENT/suggestions`
    return axios.get(url).then((res) => res.data.followedPersons ?? [])
  },

  dismissRecommendedFollowee(personId) {
    const url = `${treeDataBase}/followers/CURRENT/suggestions?personId=${personId}`
    return axios.delete(url, { personId })
  },

  // Users Following
  getPeopleFollowing(pid) {
    if (!pid) return Promise.resolve([])
    const url = `${treeDataBase}/followers?personId=${pid}`
    return axios.get(url).then((res) => res.data)
  },

  getPeopleFollowingCount(pid) {
    if (!pid) return Promise.resolve([])
    const url = `${treeDataBase}/followers/count?personId=${pid}`
    return axios.get(url).then((res) => res.data.count)
  },

  // Get list of groups user is part of
  getGroups() {
    const url = `${treeDataBase}/groups/current-groups?includePending=false`
    return axios.get(url).then((res) => res.data)
  },
}

export default listService
